var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---Login",
    transform: "translate(-720.000000, -346.000000)",
    fill: "#C5C5C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-/-label",
    transform: "translate(673.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(47.398438, 0.281250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.078125,16.15625 C12.5078125,16.15625 16.1640625,12.5 16.1640625,8.078125 C16.1640625,3.65625 12.5,0 8.0703125,0 C3.6484375,0 0,3.65625 0,8.078125 C0,12.5 3.65625,16.15625 8.078125,16.15625 Z M8.078125,14.546875 C4.4921875,14.546875 1.625,11.6640625 1.625,8.078125 C1.625,4.4921875 4.4921875,1.6171875 8.0703125,1.6171875 C11.65625,1.6171875 14.5390625,4.4921875 14.5468908,8.078125 C14.5546875,11.6640625 11.6640625,14.546875 8.078125,14.546875 Z M8.03125,5.4375 C8.6328125,5.4375 9.1015625,4.9609375 9.1015625,4.375 C9.1015625,3.765625 8.6328125,3.296875 8.03125,3.296875 C7.4453125,3.296875 6.96875,3.765625 6.96875,4.375 C6.96875,4.9609375 7.4453125,5.4375 8.03125,5.4375 Z M9.8671875,12.328125 C10.21875,12.328125 10.5,12.078125 10.5,11.71875 C10.5,11.3828125 10.21875,11.1171875 9.8671875,11.1171875 L9,11.1171875 L9,7.4296875 C9,6.9609375 8.765625,6.6484375 8.328125,6.6484375 L6.8359375,6.6484375 C6.484375,6.6484375 6.2109375,6.9140625 6.2109375,7.25 C6.2109375,7.609375 6.484375,7.8671875 6.8359375,7.8671875 L7.6328125,7.8671875 L7.6328125,11.1171875 L6.6953125,11.1171875 C6.3515625,11.1171875 6.0703125,11.3828125 6.0703125,11.71875 C6.0703125,12.078125 6.3515625,12.328125 6.6953125,12.328125 L9.8671875,12.328125 Z",
    id: "\\uDBC0\\uDD74"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.7da5f1ac.svg";
export { ForwardRef as ReactComponent };